import { Field, Float, InputType } from 'type-graphql'

// Provider-neutral checkout line item — always major units (pesos, dollars). Each gateway
// adapter converts to its own minor/major-unit convention internally (PayMongo centavos,
// HitPay major units) — no caller ever sees the gateway's unit.
@InputType()
export class CheckoutLineItem {
  @Field(() => String)
  name: string

  @Field(() => Float)
  amount: number

  @Field(() => Float)
  quantity: number

  @Field(() => String, { nullable: true })
  currency?: string

  // Merchant-facing line description — an adapter without a wire slot for it (or one that
  // deliberately doesn't render it) simply doesn't map this field; never required.
  @Field(() => String, { nullable: true })
  description?: string

  // Product image URLs — same "adapter maps it only if its wire shape has a slot" rule as
  // `description` above.
  @Field(() => [String], { nullable: true })
  images?: string[]
}
